/* tslint:disable */
/* eslint-disable */
/**
 * BS BFF(ダイナミックパッケージ/DP補助金申請) API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface JpCoBenefitoneBsdpBffPresentationResponseCmsHeaderFooterGetResponseFieldImage
 */
export interface JpCoBenefitoneBsdpBffPresentationResponseCmsHeaderFooterGetResponseFieldImage {
    /**
     * 
     * @type {string}
     * @memberof JpCoBenefitoneBsdpBffPresentationResponseCmsHeaderFooterGetResponseFieldImage
     */
    alt?: string;
    /**
     * 
     * @type {string}
     * @memberof JpCoBenefitoneBsdpBffPresentationResponseCmsHeaderFooterGetResponseFieldImage
     */
    url?: string;
}

export function JpCoBenefitoneBsdpBffPresentationResponseCmsHeaderFooterGetResponseFieldImageFromJSON(json: any): JpCoBenefitoneBsdpBffPresentationResponseCmsHeaderFooterGetResponseFieldImage {
    return JpCoBenefitoneBsdpBffPresentationResponseCmsHeaderFooterGetResponseFieldImageFromJSONTyped(json, false);
}

export function JpCoBenefitoneBsdpBffPresentationResponseCmsHeaderFooterGetResponseFieldImageFromJSONTyped(json: any, ignoreDiscriminator: boolean): JpCoBenefitoneBsdpBffPresentationResponseCmsHeaderFooterGetResponseFieldImage {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'alt': !exists(json, 'alt') ? undefined : json['alt'],
        'url': !exists(json, 'url') ? undefined : json['url'],
    };
}

export function JpCoBenefitoneBsdpBffPresentationResponseCmsHeaderFooterGetResponseFieldImageToJSON(value?: JpCoBenefitoneBsdpBffPresentationResponseCmsHeaderFooterGetResponseFieldImage | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'alt': value.alt,
        'url': value.url,
    };
}

